<template>
  <div>
    <vxe-toolbar
      id="toolbarId_tr11"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="atchPayment">
          批量支付
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      show-footer
      :footer-method="footerMethod"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ordCreatedByName"
          title="下单客户"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ordCreatedByName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物类型"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="partyType !== 'DRIVER'">
        <vxe-table-column
          field="price"
          title="托运人成交单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType !== 'SHIPMENT' && partyType !== 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="realPrice"
          title="实际承运人承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人实际运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType !== 'SHIPMENT' && partyType !== 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxFee"
          title="含税总价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPayFee"
          title="纳税金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="公里数(公里)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryOilFee"
          title="油气卡(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.deliveryOilFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryOilFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="接单数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装车数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸车数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="收货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="截止装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastLoadingTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fillTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.fillTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'fillTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="截止卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.lastUnloadingTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="signTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.signTimeRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'signTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtModifiedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="立即支付"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="orderDesil(scope.row.code)">
              <i class="el-icon-position" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { orderDetailList } from "@/api/transport";
import { obtainPrepayPush } from "@/api/InternetBanking";
export default {
  data() {
    return {
      loading: false,
      tuteship: false,
      tableData: [],
      areaOptions: this.$store.state.components.areaOptions,
      consignorAreaList: [],
      consigneeAreaList: [],
      partyType: "",
      listQuery: {
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        gmtCreatedRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      sumObject: {},
      statusOptions: [
        { value: 1, label: "已接单" },
        { value: 2, label: "已装货" },
        { value: 3, label: "已卸货" },
        { value: 4, label: "已结算" },
        { value: 5, label: "已打款" }
      ]
    };
  },
  created() {
    this.partyType = this.$store.getters.party.partyType;
  },
  methods: {
    findList(c) {
      this.listQuery.mybankPrepayCode = c;
      this.loading = true;
      return new Promise(resolve => {
        orderDetailList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    //  立即支付
    orderDesil(c) {
      this.$confirm("是否立即支付?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          obtainPrepayPush(c).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //批量支付
    atchPayment() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else {
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        const orderDetailCodes = arrcarcode.join(",");
        this.$refs.xTable.clearCheckboxRow();
        obtainPrepayPush(orderDetailCodes).then(response => {
          this.$message({
            message: response.msg,
            type: "success"
          });
          this.findList();
        });
      }
    },
    // 装货/收货地址
    changeAreaList(value, prefix) {
      if (value.length > 0) {
        this.listQuery[`${prefix}SubdivisionCode`] = value[2];
      } else {
        this.listQuery[`${prefix}SubdivisionCode`] = "";
      }
    },
    // 类型
    handleChangeCoalType(value) {
      if (value.length > 0) {
        var newValue = value.slice(0);
        this.listQuery.coalType = newValue.pop();
      } else {
        this.listQuery.coalType = "";
      }
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style lang="scss" scoped></style>
